/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react'
import Select, { components } from 'react-select'
import AsyncSelect from 'react-select/async'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Spinner from '../Spinner'

const CustomMenuList = ({ children, ...props }) => {
  return (
    <components.MenuList {...props}>
      {children}
      {(props.selectProps.loading && !props.selectProps.isLoading) && <Spinner size='small' containerStyle={{ marginTop: 5, marginBottom: 5, borderRadius: 4 }} />}
    </components.MenuList>

  )
}

const SelectComponentWithProps = forwardRef((props, ref) => {
  const SelectComponent = props.loadOptions ? AsyncSelect : Select
  return (
    <SelectComponent
      {...props}
      ref={ref}
      onMenuScrollToBottom={props.handleLoadMore}
      components={{
        MenuList: CustomMenuList
      }}
    />
  )
})

const SelectInputStyledComponent = styled(SelectComponentWithProps)`
  .react-select__control:hover {
    border-color: #000 !important;
  }

  .react-select__control--is-focused {
    border-color: #000 !important;
    box-shadow: none !important;
  }
`

const MultiselectContainer = styled.div`
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export { SelectInputStyledComponent, MultiselectContainer }

SelectComponentWithProps.propTypes = {
  loadOptions: PropTypes.func,
  handleLoadMore: PropTypes.func,
  loading: PropTypes.boolean
}
